export default "__VITE_ASSET__C7ILbp4C__"